import React from 'react';
import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import { themeColor } from '../../services/styleUtils/colorUtils';

const Container = styled('div', {
  shouldForwardProp: (prop) => prop !== 'fields',
})(({ fields }) => ({
  position: 'relative',
  width: '100%',
  backgroundColor: fields.backgroundColor,
  height: '265px',
  margin: '-25px 0 50px 0',
}));

const Title = styled('div', {
  shouldForwardProp: (prop) => prop !== 'titleColor',
})(({ titleColor }) => ({
  position: 'absolute',
  left: '20%',
  top: '10%',
  width: '260px',
  fontSize: '2.625rem',
  lineHeight: '2.875rem',
  fontWeight: 700,
  color: titleColor,
  textTransform: 'uppercase',
}));

const SubTitle = styled('div', {
  shouldForwardProp: (prop) => prop !== 'subtitleColor',
})(({ subtitleColor }) => ({
  position: 'absolute',
  left: '20%',
  top: '65%',
  width: '260px',
  fontSize: '1.25rem',
  lineHeight: '1.75rem',
  color: subtitleColor,
}));

const CenterArea = styled('div', {
  shouldForwardProp: (prop) => prop !== 'fields',
})(({ theme, fields }) => ({
  position: 'absolute',
  left: '45%',
  top: 0,
  backgroundColor:
    fields.overlayedAreaBackgroundColor || theme.palette.primary.light,
  height: '281px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '@media screen and (min-width: 1080px)': {
    width: '564px',
    '&:after': {
      borderBottom: 'solid 16px transparent',
      borderRight: 'solid 16px transparent',
      borderLeft: `solid 16px ${theme.palette.primary.main}`,
      transform: 'translateX(-50%)',
      position: 'absolute',
      zIndex: 10,
      content: '""',
      top: '94.3%',
      left: '102.8%',
      height: 0,
      width: 0,
    },
  },
  '@media screen and (max-width: 1079px)': {
    display: 'none',
  },
}));

const Option = styled('div')({
  textAlign: 'left',
  maxWidth: '95%',
  padding: '0 50px',
  margin: 0,
});

const OptionImg = styled('img')({
  color: '#fff',
});

const OptionText = styled('div', {
  shouldForwardProp: (prop) => prop !== 'color',
})(({ color = '#fff' }) => ({
  color,
  fontSize: '1.813rem',
  lineHeight: '2.278rem',
  fontWeight: 600,
}));

const WhiteCircle = styled('div')(({ theme }) => ({
  backgroundColor: '#fff',
  borderRadius: '50%',
  width: '53px',
  height: '53px',
  margin: '0 10px',
  padding: '11px',
  fontSize: '1.5rem',
  lineHeight: '1.886rem',
  color: theme.palette.primary.light,
}));

const PageBannerWithTwoOptions = ({ module }) => {
  const { fields } = module;
  const theme = useTheme();
  const titleColor = fields?.titleFontStyle?.fields.color
    ? themeColor(theme, fields?.titleFontStyle?.fields.color)
    : '#000';
  const subtitleColor = fields?.subtitleFontStyle?.fields.color
    ? themeColor(theme, fields?.subtitleFontStyle?.fields.color)
    : '#000';
  const optionOneTextColor = fields?.option1FontStyle?.fields.color
    ? themeColor(theme, fields?.option1FontStyle?.fields.color)
    : '#fff';
  const optionTwoTextColor = fields?.option2FontStyle?.fields.color
    ? themeColor(theme, fields?.option2FontStyle?.fields.color)
    : '#fff';

  return (
    <Container fields={fields}>
      <Title titleColor={titleColor}>{fields.title}</Title>
      <SubTitle subtitleColor={subtitleColor}>{fields.subTitle}</SubTitle>
      <CenterArea fields={fields}>
        <Option>
          {fields && fields.option1Icon && (
            <>
              {fields.option1Icon && (
                <OptionImg
                  src={fields.option1Icon.url}
                  alt={fields.option1Icon.text}
                />
              )}
              <OptionText color={optionOneTextColor}>
                {fields.option1Text}
              </OptionText>
            </>
          )}
        </Option>
        <WhiteCircle>OR</WhiteCircle>
        <Option>
          {fields && fields.option2Icon && (
            <>
              {fields.option2Icon && (
                <OptionImg
                  src={fields.option2Icon.url}
                  alt={fields.option2Icon.text}
                />
              )}
              <OptionText color={optionTwoTextColor}>
                {fields.option2Text}
              </OptionText>
            </>
          )}
        </Option>
      </CenterArea>
    </Container>
  );
};

export default PageBannerWithTwoOptions;
